module.exports = __webpack_public_path__ + "static/media/blob.8ca51338.svg";